import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEvent from './event.reducer';
import { EventPageConfig } from 'app/event-page/models/event-page-config-model';

export const selectEventState = createFeatureSelector<fromEvent.State>(
  fromEvent.eventFeatureKey
);

export const selectEventList = createSelector(
  selectEventState,
  (state: fromEvent.State) => {
    return _.map(state.entities, entity => entity);
  }
);

export const selectEventListSwitcher = createSelector(
  selectEventState,
  (state: fromEvent.State) => {
    return state.switcher;
  }
);

export const selectEventSelected = createSelector(
  selectEventState,
  (state: fromEvent.State) => {
    return state.selectedEvent;
  }
);

export const selectEventConfig = createSelector(
  selectEventState,
  (state: fromEvent.State) => {
    if(state.eventConfig) {
      return new EventPageConfig(state.eventConfig)
    }
    return null;
  }
);

export const selectAllStreams = createSelector(
  selectEventState,
  (state: fromEvent.State) => {
    return state && state.allStreams;
  }
);

export const selectStreamsWithVideo = createSelector(
  selectEventState,
  (state: fromEvent.State) => {
    if (state && state.allStreams && state.allStreams.length) {
      const streams = state.allStreams;
      return streams.filter(stream => stream.recordings.length > 0);
    }
    return [];
  }
);
